import { NetworkRequestState } from '../baseTypes';
import { NotificationsWidgetData } from './types';

const defaultNotificationsWidgetData: NonNullable<{
  deviantart: NonNullable<NotificationsWidgetData['initialData']['deviantart']>;
  email: NonNullable<NotificationsWidgetData['initialData']['email']>;
}> = {
  deviantart: {
    mentions: false,
    badges: false,
    deviantartProtect: false,
    newMembers: false,
  },
  email: {
    accountActivity: false,
    news: false,
    passwordReset: false,
  },
};

export const defaultNotificationsWidgetState: NotificationsWidgetData = {
  initialData: defaultNotificationsWidgetData,
  currentData: defaultNotificationsWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
